module.exports = __webpack_public_path__ + "static/img/zzww.b339fcd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/course/zzww.jpg
// module id = 0w0k
// module chunks = 0